import React from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

export const VenueContext = React.createContext<Venue | undefined>(undefined);

export const useVenueContext = () => {
  const venue = React.useContext(VenueContext);
  if (!venue) {
    throw new Error('useVenueContext must be used within VenueContextProvider');
  }
  return venue;
};

export const VenueContextProvider = VenueContext.Provider;
